import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import CodifySpecificationsEditor from "./CodifySpecificationsEditor";
import { useAuthenticatedRequest } from "./hooks/useAuthenticatedRequest";

const CodifySpecificationsEditorPage = () => {
  const { codifySpecificationId } = useParams();
  const navigate = useNavigate();
  const { get, post, put } = useAuthenticatedRequest();
  const [codifySpecification, setCodifySpecification] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = codifySpecificationId === "new";

  const createEmptyCodifySpecification = () => ({
    _id: crypto.randomUUID(),
    name: "",
    description: "",
    status: "draft",
    isDefault: false,
    ownerPartyId: "",
    codifyCollection: "",
    dataStandard: "",
    dataType: "",
    modelProvider: "",
    model: "",
    updatedBy: "",
    updatedDate: new Date().toISOString(),
    createdBy: "",
    createdDate: new Date().toISOString(),
  });

  useEffect(() => {
    const fetchCodifySpecification = async () => {
      if (isNew) {
        setCodifySpecification(createEmptyCodifySpecification());
        setLoading(false);
      } else {
        try {
          const response = await get(`https://codify.poc.mrc.ai/api/specifications/${codifySpecificationId}`);
          setCodifySpecification(response.data);
        } catch (error) {
          console.error("Error fetching codify specification:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCodifySpecification();
  }, [codifySpecificationId, isNew]);

  const handleSave = async (updatedCodifySpecification) => {
    try {
      const url = isNew
        ? `https://codify.poc.mrc.ai/api/specifications`
        : `https://codify.poc.mrc.ai/api/specifications/${codifySpecificationId}`;

      const response = isNew
        ? await post(url, updatedCodifySpecification)
        : await put(url, updatedCodifySpecification);

      setCodifySpecification(response.data);
    } catch (err) {
      console.error("Error saving codify specification:", err);
    }
  };

  const handleClose = () => navigate("/codify");

  if (loading) return <Spinner />;

  return <CodifySpecificationsEditor codifySpecification={codifySpecification} onClose={handleClose} isNew={isNew} />;
};

export default CodifySpecificationsEditorPage;
